export default __webpack_public_path__ + "static/media/account_circle.69e03354.svg";